<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="$t('environmental-management.route-management.title')">
        </base-page-header>

        <v-row>
            <v-col cols="12" class="text-right pt-0 mb-3">
                <span @click="handlerOnClick(infoRoute.prev)" v-show="infoRoute.currentLen != 1" class="cursor-pointer">
                    <img src="/images/_SVGs/environmental/seta-direita-small.svg" width="22" height="22" alt="Prev" class="rotation-180" onload="SVGInject(this)" />
                </span>

                <span class="qtd-route">
                    <span class="current">{{infoRoute.currentLen}}</span>/{{routes.length}}
                </span>

                <span @click="handlerOnClick(infoRoute.next)" v-show="infoRoute.currentLen < routes.length" class="cursor-pointer">
                    <img src="/images/_SVGs/environmental/seta-direita-small.svg" width="22" height="22" alt="Next" onload="SVGInject(this)" />
                </span>
            </v-col>
        </v-row>

        <v-row class="bg-white p-3" style="border-radius: 7px">
            <v-col cols="12" sm="8" class="pt-0">
                <span class="subTitleCurso">
                    {{ transporterInfo.transportationStartDate | formatOnlyDate }} <!--| {{ infoRoute.kms}} Km-->
                </span>
            </v-col>
            <v-col cols="12" sm="4" class="text-md-right text-center pt-0">
                <v-row>
                    <v-col cols="3" class="d-flex align-center justify-end" style="justify-content: flex-end; ">
                        <img src="/images/_SVGs/environmental/oficinas.svg" width="22" height="22" onload="SVGInject(this)" />
                        {{doneEgars}}/{{infoRoute.totalEgars}}
                    </v-col>
                    <v-col cols="9" class="d-flex align-center justify-end">
                        <v-progress-linear :value="infoRoute.totalEgars == 0? 100 : calcPercentual(infoRoute.totalEgars,doneEgars)"></v-progress-linear>
                    </v-col>
                </v-row>
            </v-col>


            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="egars"
                    :server-items-length="totalItemsTable"
                    :page="page"
                    :pageCount="numberOfPages"
                    :options.sync="options"
                    :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-options': [10, 20, 50]
                    }"
                    v-if="tableHisReady"
                >
                    <template v-slot:[`item.id`]="{ index }">
                        {{ index + 1}}
                    </template>
                    <template v-slot:[`item.createDate`]="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:[`item.producer`]="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>
                    <template v-slot:[`item.morada`]="{ item }">
                        {{item.producer.address}} {{item.producer.locality}}
                    </template>
                    <template v-slot:[`item.transportedResidue`]="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:[`item.qtd`]="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>


                    <template v-slot:[`item.action`]="{ index, item }">
                        <div class="d-flex justify-center align-center h-80" v-if="item.routeEgarStatusID == 1">
                            <div class="text-center">
                                <p class="tr-status">
                                    <img src="/images/_SVGs/environmental/check.svg" alt="Recolhido" onload="SVGInject(this)" width="15" height="15" /> Recolhido
                                </p>
                                <p class="tr-kg">
                                    {{item.egarQtdCollected}} kg
                                </p>
                            </div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <a @click="getArchive(item)" target="_blank"  v-bind="attrs" v-on="on">
                                        <img src="/images/_SVGs/environmental/guia transporte.svg" class="ml-5 circle" alt="add item" onload="SVGInject(this)" width="20" height="20" />
                                    </a>
                                </template>
                                <span>{{$t('environmental-management.route-management.edit-conveyor.download-guide')}}</span>
                            </v-tooltip>

                        </div>

                        <div class="d-flex justify-center align-center h-80" v-else-if="item.routeEgarStatusID == 2">
                            <div class="text-center danger-egar">
                                <p class="tr-status">
                                    <img src="/images/_SVGs/environmental/fechar.svg" alt="Rejeitado" onload="SVGInject(this)" width="15" height="15" /> {{$t('environmental-management.scheduling.status.not-collected')}}
                                </p>
                                <p class="tr-kg">
                                    {{item.routeEgarReason}}
                                </p>
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="item.recolher == false">
                                <div class="d-flex justify-center align-center pt-2 pb-2">
                                    <v-btn
                                    class="no-get mr-3 col-5 col-sm-6"
                                    height="60"
                                    @click="rejectedEgar(item.egarId)"
                                    >{{$t('no')}}<br> {{$t('environmental-management.route-management.edit-conveyor.to-recall')}}</v-btn>

                                    <v-btn
                                    class="get col-5 col-sm-6"
                                    height="60"
                                    @click="recolherEgar(index)"
                                    >{{$t('environmental-management.route-management.edit-conveyor.to-recall')}}</v-btn>
                                </div>
                            </div>

                            <div v-else>
                                <div class="d-flex justify-center align-center pt-2 pb-2 h-80" v-show="item.recolher == true">
                                        <v-text-field
                                            v-model="formRecolher.qtd"
                                            :label="$t('environmental-management.route-management.edit-conveyor.qty')"
                                            class="qtdKG"
                                            outlined
                                            hide-details="auto"
                                        ></v-text-field>

                                        <p class="ml-2 tr-status">
                                            <v-btn class="get" height="60" @click="preSubmitCollected(item)" :disabled="formRecolher.qtd == 0 || formRecolher.qtd == ''"
                                            >{{$t('confirm')}}</v-btn>
                                        </p>
                                </div>
                            </div>

                        </div>
                    </template>
                </v-data-table>
            </v-col>

            <v-col cols="12" class="d-flex justify-end">
                <div class="btn-add" @click="modalCreateEgar()">
                    <img src="/images/_SVGs/bo/adicionar.svg" alt="add item" onload="SVGInject(this)" class="circle" width="15" />
                </div>
            </v-col>

        </v-row>

        <v-row class="mt-4"  v-if="doneEgars == infoRoute.totalEgars">
            <v-col cols="12" class="mx-auto text-center">
                <v-btn rounded class="btn-primary-custom" @click="concluiRouter">{{$t('environmental-management.route-management.edit-conveyor.finish-route')}}</v-btn>
            </v-col>
        </v-row>

        <base-modal v-model="modalNewEgar.show" :title="$t('environmental-management.route-management.create-recall-request')" modalAlign="align__flex--center" modal-width="2000px">
            <template v-slot:modal-body>
                <v-form v-model="modalNewEgar.isValid" v-if="modalNewEgar.show">
                    <v-row class="bg-white p-3" >
                        <v-col cols="12" sm="4">
                            <v-autocomplete
                                :items="actorsSenders.length > 0? actorsSenders.map(el => ({text: el.description,value: el})) : []"
                                v-model="selectActorsSenders"
                                filled
                                :rules="formInputs.default.rules"
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.intervenient-type-req')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete
                            :items="actorsSenderTypes.length > 0? actorsSenderTypes.map(el => ({text: el.description,value: el})) : []"
                            v-model="selectActorsSendersType"
                            filled
                            :rules="formInputs.default.rules"
                            hide-details="auto"
                            :label="$t('environmental-management.route-management.profile-type-req')"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="12">
                            <hr>
                        </v-col>
                        <v-col cols="12">
                            <h3>{{$t('environmental-management.route-management.producer')}}</h3>
                        </v-col>

                        <v-col cols="12" sm="2">
                            <v-text-field
                            filled
                            v-model="form.producerEstablishment.nif"
                            @blur="getProducersEstablishmentNif()"
                            hide-details="auto"
                            :rules="formInputs.nif.rules"
                            :label="$t('environmental-management.route-management.producer-nif')"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-select
                            v-model="form.producerType"
                            :items="producerType.length > 0? producerType.map(el => ({text: el.description,value: +el.producerTypeId})) : []"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.route-management.type-req')"
                            :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-select
                            v-model="selectProducerEstablishment"
                            :items="producersEstablishment.length > 0? producersEstablishment.map(el => ({text: el.name,value: el})) : []"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.route-management.establishment-req')"
                            :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="d-flex align-center">
                            <v-btn small v-if="producersEstablishment.length > 0" @click="obterProducer"> {{$t('environmental-management.route-management.get-establishments')}} </v-btn>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field
                            v-model="form.producerEstablishment.address"
                            filled
                            :rules="formInputs.default.rules"
                            hide-details="auto"
                            readonly
                            :label="$t('environmental-management.route-management.address-req')"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                            v-model="form.producerEstablishment.postalCode"
                            filled
                            hide-details="auto"
                            :rules="formInputs.default.rules"
                            readonly
                            :label="$t('environmental-management.route-management.postal-code-req')"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                            v-model="form.producerEstablishment.locality"
                            filled
                            hide-details="auto"
                            :rules="formInputs.default.rules"
                            readonly
                            :label="$t('environmental-management.route-management.locale-req')"
                            ></v-text-field>
                        </v-col>


                        <v-col cols="12">
                            <hr>
                        </v-col>
                        <v-col cols="12">
                            <h3>{{$t('environmental-management.route-management.residue-operator')}}</h3>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-combobox
                                clearable
                                filled
                                v-model="form.recipientEstablishment.nif"
                                :items="nifOGR"
                                :rules="formInputs.nif.rules"
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.nif-ogr-req')"
                                @change="getRecipientEstablishmentNif()"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-select
                                v-if="recipientsEstablishment.length > 0"
                                v-model="selectRecipientEstablishment"
                                :items="recipientsEstablishment.length > 0? recipientsEstablishment.map(el => ({text: el.name,value: el})) : []"
                                :rules="formInputs.default.rules"
                                filled
                                hide-details="auto"
                                :label="$t('environmental-management.route-management.establishments')"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="d-flex align-center">
                            <v-btn small v-if="recipientsEstablishment.length > 0" @click="obterRecipient"> {{$t('environmental-management.route-management.get-establishments')}} </v-btn>
                        </v-col>

                        <v-col cols="12">
                            <hr>
                        </v-col>
                        <v-col cols="12">
                            <h3>{{$t('environmental-management.route-management.residue')}}</h3>
                        </v-col>
                        <v-col cols="12" v-for="(residuo, index) in form.residuos" :key="index">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-autocomplete
                                    :items="lerCodes.length > 0? lerCodes.map(el => ({text: el.description, value: el.lerCodeId})) : []"
                                    :rules="formInputs.default.rules"
                                    filled
                                    @change="getOperationCodes(residuo.lerCodeId, index, residuo)"
                                    v-model="residuo.lerCodeId"
                                    hide-details="auto"
                                    :label="$t('environmental-management.route-management.residue-designation')"
                                    ></v-autocomplete>

                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-text-field
                                    v-model="residuo.codigoLer"
                                    :rules="formInputs.default.rules"
                                    filled
                                    hide-details="auto"
                                    :label="$t('environmental-management.route-management.ler-code-req')"
                                    readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-autocomplete
                                    :items="residuo.operations? residuo.operations.map(el => ({text: el.operationCode,value: +el.operationCodeID})) : []"
                                    v-model="residuo.operationCodeId"
                                    @change="changeOperationCode(index)"
                                    :rules="formInputs.default.rules"
                                    filled
                                    hide-details="auto"
                                    :label="$t('environmental-management.route-management.code-operator-req')"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1">
                                    <v-text-field
                                    v-model="residuo.quantity"
                                    :rules="formInputs.default.rules"
                                    filled
                                    hide-details="auto"
                                    :label="$t('environmental-management.route-management.qty')"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2">
                                  <v-autocomplete
                                      :items="containerTypesItems"
                                      v-model="residuo.containerTypeID"
                                      :rules="formInputs.default.rules"
                                      filled
                                      hide-details="auto"
                                      :label="$t('backoffice.environmental.containers.title')"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="2">
                                  <v-text-field
                                    v-model="residuo.containerQuantity"
                                    :rules="formInputs.default.rules"
                                    filled
                                    hide-details="auto"
                                    :label="$t('backoffice.environmental.containers.qty')"
                                  ></v-text-field>
                                </v-col>
                                <v-col v-if="form.residuos.length > 1 && index > 0" cols="12" sm="1" class="d-flex align-center justify-center" style="cursor: pointer;">
                                  <span class="btn-remove" @click="handleDeleteResidue(residuo, index)">
                                    <img src="/images/_SVGs/bo/remove.svg" :alt="$t('environmental-management.scheduling.remove-item-alt')" onload="SVGInject(this)" class="circle" width="15" />
                                  </span>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="p-0 mb-4" >
                          <div class="float-md-left mr-md-4 btn-add ml-3" @click="addNewResidue">
                              <img src="/images/_SVGs/bo/adicionar.svg" alt="add item" onload="SVGInject(this)" class="circle" width="30" />
                          </div>
                      </v-col>
                    </v-row>
                </v-form>

            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelCreateEgar()">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="grey-button" text @click="printEgarForm()" :disabled="!modalNewEgar.valideProducer">
                        {{ $t('print') }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="saveEgar(2)" :disabled="!modalNewEgar.isValid">
                        {{$t('create')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalRecolha.show" :title="$t('environmental-management.route-management.edit-conveyor.specify-reason')" modalAlign="align__flex--center" modal-width="560px">
            <template v-slot:modal-body>
                <v-form v-model="modalRecolha.isValid">
                    <v-col cols="12">
                        <v-radio-group
                        v-model="reason"
                        :rules="formRules.defaultRules"
                        >
                            <v-radio
                                :label="$t('environmental-management.route-management.edit-conveyor.establishment-closed')"
                                :value="$t('environmental-management.route-management.edit-conveyor.establishment-closed')"
                            ></v-radio>
                            <v-radio
                                :label="$t('environmental-management.route-management.edit-conveyor.residue-not-available')"
                                :value="$t('environmental-management.route-management.edit-conveyor.residue-not-available')"
                            ></v-radio>
                            <v-radio
                                :label="$t('environmental-management.route-management.edit-conveyor.disassociate-from-route')"
                                :value="$t('environmental-management.route-management.edit-conveyor.disassociate-from-route')"
                            ></v-radio>
                            <v-radio
                                :label="$t('environmental-management.route-management.edit-conveyor.other-reason')"
                                value="other"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" v-if="reason == 'other'">
                        <v-text-field
                            :label="$t('environmental-management.route-management.edit-conveyor.other-reason-req')"
                            v-model="reasonOther"
                            :rules="reason == 'other'? formRules.defaultRules : []"
                            filled
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                </v-form>

            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancerConfirmRecolha()">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="confirmCancelRecolha()" :disabled="!modalRecolha.isValid">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalAlert.show" :title="modalAlert.title" modal-width="560px" :iconColor="modalAlert.iconColor" :iconName="modalAlert.iconName">
            <template v-slot:modal-close>
                <div @click="modalAlert.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn text :color="modalAlert.iconColor == 'warning' ? 'danger-button' : 'primary-button'" @click="clickOkModalAlert()">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalSignature.show" :title="$t('environmental-management.route-management.edit-conveyor.signature')" modalAlign="align__flex--center" modal-width="900px">
            <template v-slot:modal-body>
                <div v-if="modalSignature.signature" class="row-signature" style="background: #ccc; position: relative; margin: 0 auto;" :style="$vuetify.breakpoint.xsOnly ? 'width: 225px;' : $vuetify.breakpoint.smOnly ? 'width: 450px;' : 'width: 850px;'">
                    <vueSignature v-if="modalSignature.signature" ref="signature" :sigOption="option" :w="$vuetify.breakpoint.xsOnly ? '225px' : $vuetify.breakpoint.smOnly ? '450px' : '850px'" :h="'200px'"></vueSignature>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="closeSignature">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div>
                    <v-btn class="info-button" text @click="clearSignature">
                        {{$t('clear')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="submitCollected(modalSignature.item)">
                        {{$t('confirm')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalCompleteRoute.show" :title="modalCompleteRoute.title" modal-width="560px">
            <template v-slot:modal-close>
                <div @click="modalCompleteRoute.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalCompleteRoute.msg}}
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn text :color="'primary-button'" @click="clickOkModalCompleteRoute()">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import { GetTranporterRouters, RejectedEgar,GetTransporterToRoute,CollectedEgar,GetTranporterGuideEgar,CompleteRouterById } from '@services/b2b/environmental-management/RouterService'
    import {
        GetEgars, GetEgarPreFilled, GetEstablishment, GetProducerTypes, GetLerCode, GetOperationCode, GetActorsSenders,
        PostOrderEgarToRouter, PostPrintEgarForm
    } from '@services/b2b/environmental-management/EgarService';
    import { required, maxLength, minLength } from '@src/utils/validations.js';
    import vueSignature from "vue-signature"
    import { EnvironmentalDocServicesGetSILiAmbContainerTypes } from '@services/b2b/environmental-management/DocumentationService';
    import BaseModal from "@components/shared/widgets/BaseModal.vue";
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

    export default {
        components:{
            BasePageHeader,
            BaseModal,
            vueSignature
        },
        data(){
            return{
                modalCompleteRoute:{
                    show: false,
                    msg: '',
                    title: ''
                },
                windowWidth: window.innerWidth,
                signatureWidth: 0,
                modalSignature: {
                    show: false,
                    signature: true,
                    item: null
                },
                option: {
                    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"transparent"
                },
                nifOGR: [],
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.title'),
                        routerLinkName: 'environmentalManagementRouteManagement'
                    },
                    {
                        title: ''
                    }
                ],

                transporterInfo: {
                    name: '',
                    nif: '',
                    plateNumber: '',
                    transportationStartDate: ''

                },
                infoRoute: {
                    name: '',
                    kms: 0,
                    statusId: 1,
                    totalEgars: 0,
                    currentLen:0,
                    doneEgars: 0,
                    next: 0,
                    prev: 0,
                    maxEgarRequest: 0,
                    siLiAmbMainRouteID: 0,
                    transportationStartDate: ''
                },
                routeId: 0,
                routes:[],

                headers: [
                    {
                        text: '#',
                        align: 'start',
                        value: 'id',
                        sortable: false
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producer'), value: 'producer', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.adress'), value: 'morada', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.residue'), value: 'transportedResidue', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.qtd'), value: 'qtd', sortable: false },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.status'), value: 'action', sortable: false },

                ],

                egars: [],
                modalRecolha:{
                    show:false,
                    isValid: false,
                    egarId: 0
                },
                routesTransporterNow: [],
                routesTransporterTomorrow: [],
                routesTransporterOthers: [],


                modalAlert: {
                    show: false,
                    noRefresh: false,
                    msg: '',
                    message: '',
                    title: this.$t('heads-up'),
                    iconName: '',
                    iconColor: '',
                    buttonRedirect: false
                },

                reason: null,
                reasonOther: '',

                formRules: {
                    defaultRules: [required]
                },
                formInputs: {
                    default: {
                        rules: [required]
                    },
                    nif: {
                        rules: [required, minLength(9),maxLength(9)]
                    },

                },
                tableHisReady: true,
                formRecolher: {
                    egarId: 0,
                    qtd: 0
                },
                transporterInfo: {
                    name: '',
                    nif: '',
                    plateNumber: '',
                    transportationStartDate: '',
                },


                modalNewEgar:{
                    show: false,
                    isValid: false,
                    valideProducer: false,
                },
                form: {
                    codigoLer: null,
                    valide: false,
                    producerType: 0,
                    producerEstablishment: {
                        nif: '',
                        name: '',
                        address: '',
                        postalCode: '',
                        locality: '',
                        apaCode: ''
                    },
                    recipientEstablishment: {
                        nif: "",
                        name: "",
                        address: "",
                        postalCode: "",
                        locality: "",
                        apaCode: ""
                    },
                    residuos: [{
                        designation: "",
                        lerCodeId: "",
                        operationCodeId: 0,
                        quantity: 0,
                        groupCode: "",
                        numberPgl: "",
                        containerTypeID: "",
                        containerQuantity: 0,
                        operations: [],
                    }]
                },
                actorsSenders: [],
                selectActorsSenders: [],
                actorsSenderTypes: [],
                selectActorsSendersType: null,
                producerType: [],
                selectProducerEstablishment: [],
                producersEstablishment: [],
                recipientsEstablishment: [],
                selectRecipientEstablishment: null,
                lerCodes:[],

                fileTransform: null,
                isRefreshProducers: false,
                isRefreshRecipient: false,

                page: 1,
                numberOfPages: 1,
                options: {
                    page: 1,
                    itemsPerPage: 10
                },
                totalItemsTable: 1,
                containerTypesItems: []
            }
        },
        watch:{
            routes: {
                handler: function(newValue, oldValue) {
                    if(newValue.length > 0){
                        const indexRouter = newValue.findIndex(el => el.routeId == this.routeId)
                        const filterRouters = newValue.filter(el => el.routeId == this.routeId)
                        if(filterRouters[0]){
                            let filterRouter = filterRouters[0];
                            this.breadcrumb[2].title = filterRouter.name
                            this.infoRoute.name = filterRouter.name
                            this.infoRoute.currentLen = newValue.findIndex(el => el.routeId == this.routeId) + 1

                            this.infoRoute.next = newValue[indexRouter + 1]?.routeId
                            this.infoRoute.prev = newValue[indexRouter - 1]?.routeId
                            this.infoRoute.statusId = filterRouter.statusId
                            this.infoRoute.totalEgars = filterRouter.totalEgars
                            //this.infoRoute.doneEgars = filterRouter.doneEgars
                            this.infoRoute.maxEgarRequest = filterRouter.maxEgarRequest
                            this.infoRoute.siLiAmbMainRouteID = filterRouter.siLiAmbMainRouteID
                            this.infoRoute.transportationStartDate = filterRouter.transportationStartDate
                        }

                        this.getTransporter()
                    }
                },
                deep: true,
                immediate: false,
            },
            selectProducerEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.producerEstablishment.apaCode= newValue.apaCode
                        this.form.producerEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.producerEstablishment.address= newValue.headquartersAddress
                        this.form.producerEstablishment.locality= newValue.headquartersLocality
                        this.form.producerEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.producerEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectRecipientEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.recipientEstablishment.apaCode= newValue.apaCode
                        this.form.recipientEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.recipientEstablishment.address= newValue.headquartersAddress
                        this.form.recipientEstablishment.locality= newValue.headquartersLocality
                        this.form.recipientEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.recipientEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectActorsSenders:{
                handler: function(newValue, oldValue) {
                    if(newValue.sendersType){
                        this.actorsSenderTypes = newValue.sendersType

                        this.selectActorsSendersType = newValue.sendersType[0]
                    }
                },
                immediate: true,
                deep: true
            },
            windowWidth(newWidth) {
                //$vuetify.breakpoint.xsOnly ? '225px' : $vuetify.breakpoint.smOnly ? '450px' : '850px'
                this.resizeSignature()
            },
            "options.page": {
                handler: function(newValue, oldValue) {
                    this.getAllEGAR(this.options);
                },
            },
            "options.itemsPerPage": {
                handler() {
                    this.getAllEGAR(this.options);
                },
            },
            form: {
                handler: function (newVal) {
                    this.checkProducerValidity();
                },
                deep: true
            },
        },
        computed:{
            userState() {
                return this.$store.getters['auth/getState'];
            },
            doneEgars() {
                if(!this.routes || this.routes.length == 0) return 0;
                let route = this.routes.find(o => o.routeId == this.routeId);
                return route.doneEgars;
                const filtered = this.egars.filter(item => item.routeEgarStatusID && (item.routeEgarStatusID == 1 || item.routeEgarStatusID == 2) && item.status !== 1 && item.status !== 2);
                return filtered ? filtered.length : 0;
            }
        },
        methods: {
            clickOkModalCompleteRoute(){
                this.$router.push({name: 'environmentalManagementRouteManagement'});
            },
            concluiRouter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return CompleteRouterById(this.routeId)
                .then(response => {
                    this.modalCompleteRoute.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg1')
                    this.modalCompleteRoute.title = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.title1')
                    this.modalCompleteRoute.show = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg2')
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    throw new Error('error to get CompleteRouterById egar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            resizeSignature(){
                this.modalSignature.signature = false;
                setTimeout(() => {
                    this.modalSignature.signature = true;
                }, 500);
            },
            closeSignature(){
                this.modalSignature.show = false;
                this.modalSignature.signature = false;
                this.modalSignature.signature = true;

                this.clearSignature();
            },
            clearSignature(){
                var _this = this;
                _this.$refs.signature.clear();
            },
            getArchive(item){
                if(item.isProductor)
                {
                    window.open(item.egarLink,'_blank');
                    return
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetTranporterGuideEgar(item.egarLink)
                .then(response => {
                    window.open(response.data.result,'_blank');
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get GetTranporterGuideEgar egar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            clickOkModalAlert(){
                if(this.modalAlert.buttonRedirect){
                    this.$router.go();
                }else{
                    this.modalAlert.show = false;
                }
            },
            cancelCreateEgar(){
                this.modalNewEgar.show = false;
                this.form = {
                    codigoLer: null,
                    valide: false,
                    producerType: 0,
                    producerEstablishment: {
                        nif: '',
                        name: '',
                        address: '',
                        postalCode: '',
                        locality: '',
                        apaCode: ''
                    },
                    recipientEstablishment: {
                        nif: "",
                        name: "",
                        address: "",
                        postalCode: "",
                        locality: "",
                        apaCode: ""
                    },
                    residuos: [{
                        designation: "",
                        lerCodeId: "",
                        operationCodeId: 0,
                        quantity: 0,
                        groupCode: "",
                        numberPgl: "",

                        operations: [],
                    }]
                }

                this.selectProducerEstablishment = []
            },
            modalCreateEgar(){
                //this.getEgarPreFilled()
                this.form.recipientEstablishment.nif = this.userState.nif.substr(2)
                this.nifOGR = [this.userState.nif.substr(2)]

                this.getTypeProducer()
                this.getLerCodes()
                this.getActorsSender()
                //this.form.recipientEstablishment.nif = this.userState.nif
                this.getRecipientEstablishmentNif()


                this.modalNewEgar.show = true
            },
            obterProducer(){
                this.isRefreshProducers = true;
                this.getProducersEstablishmentNif()
            },
            getProducersEstablishmentNif(){
                this.selectProducerEstablishment = [];
                this.form.producerEstablishment.name = ''
                this.form.producerEstablishment.address = ''
                this.form.producerEstablishment.postalCode = ''
                this.form.producerEstablishment.locality = ''
                this.form.producerEstablishment.apaCode = ''

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshProducers
                };
                if(this.form.producerEstablishment.nif){
                    if(this.form.producerEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.producerEstablishment.nif,
                        isRefresh: this.isRefreshProducers
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.producersEstablishment = response.data.result

                                this.form.producerType = this.producerType[0].producerTypeId

                                this.selectProducerEstablishment = this.producersEstablishment[0]
                            }else{
                                this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg3')
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshProducers = false
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.checkProducerValidity();
                        })
                }
                return
            },
            obterRecipient(){
                this.isRefreshRecipient = true;
                this.getRecipientEstablishmentNif()
            },
            getRecipientEstablishmentNif(){
                this.selectRecipientEstablishment = [];
                this.form.recipientEstablishment.name = ''
                this.form.recipientEstablishment.address = ''
                this.form.recipientEstablishment.postalCode = ''
                this.form.recipientEstablishment.locality = ''
                this.form.recipientEstablishment.apaCode = ''
                this.recipientsEstablishment = [];

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshRecipient
                };
                if(this.form.recipientEstablishment.nif){
                    if(this.form.recipientEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.recipientEstablishment.nif,
                        isRefresh: this.isRefreshRecipient
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.recipientsEstablishment = response.data.result
                                this.selectRecipientEstablishment = response.data.result[0]
                            }else{
                                this.form.recipientEstablishment.nif = ''
                                this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg4')
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                            this.form.recipientEstablishment.nif = ''
                            this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg4')
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            this.form.recipientEstablishment.nif = ''
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshRecipient = false;
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.checkProducerValidity();
                        })
                }
                return
            },
            getOperationCodes(lerCode, index, residuo){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const lerCodes = _.cloneDeep(this.lerCodes)
                residuo.codigoLer = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].lerCode
                residuo.designation = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].description
                return GetOperationCode(lerCode)
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.form.residuos[index].operations = response.data.result
                            residuo.operationCodeId = response.data.result? response.data.result[0].operationCodeID : null

                            const findR12 = response.data.result.filter(elem => elem.operationCode == 'R12');
                            if(findR12 && findR12.length > 0) {
                                residuo.operationCodeId = findR12[0].operationCodeID;
                            }
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetLerCode values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            changeOperationCode(index){
                if(this.form.residuos[index].operationCodeId){
                    this.operationCodes.map(el =>
                    {
                        if(el.operationCodeID == this.form.residuos[index].operationCodeId){
                            this.form.residuos[index].groupCode = el.operationCode
                            this.form.residuos[index].operationCode = el.operationCode
                            this.form.residuos[index].numberPgl = el.averageWeight
                        }

                    })
                }
            },
            getEgarPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetEgarPreFilled()
                    .then(response => {
                        if(response.data.result){
                            this.form.producerEstablishment.nif = response.data.result.producerNif
                            this.producersEstablishment = response.data.result.producerEstablishments.map(el => {
                                return {
                                    apaCode: el.apaCode,
                                    authorizeIssuance: true,
                                    headquartersAddress: el.fullName,
                                    headquartersLocality: el.locality,
                                    headquartersPostalCode: el.postalCode,
                                    name: el.name,
                                    nif: response.data.result.producerNif,
                                }
                            })
                            this.recipientsEstablishment = response.data.result.recipientEstablishments.map(el => {
                                return {
                                    apaCode: el.apaCode,
                                    authorizeIssuance: true,
                                    headquartersAddress: el.fullName,
                                    headquartersLocality: el.locality,
                                    headquartersPostalCode: el.postalCode,
                                    name: el.name,
                                    nif: response.data.result.recipientNif,
                                }
                            })

                            this.selectRecipientEstablishment = this.recipientsEstablishment[0]
                            this.form.recipientEstablishment.nif = response.data.result.recipientNif
                            this.nifOGR = response.data.result.recipientNif
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        this.getRecipientEstablishmentNif()
                    })
            },
            getTypeProducer(){
                if(this.producerType.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetProducerTypes()
                        .then(response => {
                            this.producerType = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetProducerTypes egar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getLerCodes(){
                if(this.lerCodes.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetLerCode()
                        .then(response => {
                            this.lerCodes = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetLerCode values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getActorsSender(){
                if(this.actorsSenders.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetActorsSenders()
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.actorsSenders = response.data.result
                                if(!this.userState.isAdminSILiAmb){
                                    this.selectActorsSenders = this.actorsSenders.filter(el => el.code == 'D')[0]
                                }
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetActorsSenders values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }

            },

            saveEgar(status){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                this.modalNewEgar.show = false;
                if(this.form.producerEstablishment.apaCode == this.form.recipientEstablishment.apaCode){

                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg5')
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    this.$store.commit('loadings/setStateLoadingTemplate', false);

                    return
                }
                let body = {
                    egar: {
                        producerNif: this.form.producerEstablishment.nif,
                        actorTypeId: this.selectActorsSenders.actorTypeID,
                        producerTypeId: this.form.producerType,
                        senderTypeId: this.selectActorsSendersType.senderTypeID,
                        recipientNif: this.form.recipientEstablishment.nif,
                        statusId: status,
                        producerEstablishment: {
                            name: this.form.producerEstablishment.name,
                            address: this.form.producerEstablishment.address,
                            postalCode: this.form.producerEstablishment.postalCode,
                            locality: this.form.producerEstablishment.locality,
                            apaCode: this.form.producerEstablishment.apaCode
                        },
                        recipientEstablishment: {
                            name: this.form.recipientEstablishment.name,
                            address: this.form.recipientEstablishment.address,
                            postalCode: this.form.recipientEstablishment.postalCode,
                            locality: this.form.recipientEstablishment.locality,
                            apaCode: this.form.recipientEstablishment.apaCode
                        },
                        residues: this.form.residuos
                    }
                }
                return PostOrderEgarToRouter(this.routeId, body)
                .then(response => {
                    this.form.recipientEstablishment.nif = ''
                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg6')
                    this.modalAlert.title = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.title2')
                    this.modalAlert.iconName = 'mdi-shield-check';
                    this.modalAlert.iconColor = 'success';
                    this.modalAlert.show = true;
                    this.modalAlert.buttonRedirect = true
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    this.form.recipientEstablishment.nif = ''
                    this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg7')
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    throw new Error('error to get GetActorsSenders values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },


            rejectedEgar(egarId){
                this.modalRecolha.egarId = egarId

                this.modalRecolha.show = true
            },
            async recolherEgar(index){
                this.tableHisReady = false
                this.egars[index].recolher = true
                this.formRecolher.qtd = this.egars[index].transportedResidue[0].quantity
                await this.$nextTick();
                this.tableHisReady = true
            },
            preSubmitCollected(item){
                if(item.isProductor)
                {
                    this.submitCollected(item)
                }else{
                    this.modalSignature.show = true
                    this.modalSignature.item = item
                }
            },
            async submitCollected(item) {
                this.modalSignature.show = false;

                this.$store.commit('loadings/setStateLoadingTemplate', true);

                let nifInter = this.userState.nif.substr(2);
                if (item.actorType == 1){
                    nifInter = item.producer.nif;
                }

                let formData = new FormData();

                if(!item.isProductor)
                {
                    const signature = await this.$refs.signature.save();

                    const signatureResponse = await fetch(signature);
                    const blob = await signatureResponse.blob();
                    const myFile = new File([blob], "file_name.png", { type: "image/png" });

                    formData.append('signature', myFile);
                }

                let body = {
                    "interveningNif": nifInter,
                    "egar": {
                        "producerTypeId": item.producerType,
                        "sender": {
                            "nif": item.producer.nif,
                            "senderTypeId": item.senderType,
                            "establishmentApaCode": item.producer.apaCode
                        },
                        "recipient": {
                            "nif": item.recipient.nif,
                            "apaCode": item.recipient.apaCode
                        },
                        "transporters": {
                            "nif": this.transporterInfo.nif,
                            "plateNumber": this.transporterInfo.plateNumber,
                            "transportationStartDateTime": new Date().toISOString(),
                            "orderNumber": 1
                        },
                        "tranportedResidue": {
                            "designation": item.transportedResidue[0].designation,
                            "residueLerCode": item.transportedResidue[0].residueLerCode,
                            "operationCode": item.transportedResidue[0].operationCode,
                            "quantity": this.formRecolher.qtd,
                        }
                    },
                    "interveningTypeId": item.actorType
                }

                body = JSON.stringify(body);
                formData.append('request', body);

                return CollectedEgar(item.egarId, formData)
                    .then(response => {

                        if (response.status == 204){
                            this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg8')
                            this.modalAlert.show = true;
                        } else {
                            //this.infoRoute.doneEgars = this.infoRoute.doneEgars +1
                            this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg9')
                            this.modalAlert.show = true;
                            this.formRecolher.qtd = 0;

                            this.getAllEGAR()
                        }

                    })
                    .catch(error => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg8')
                        this.modalAlert.show = true;

                        throw new Error('error to put RejectedEgar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);

                        this.modalSignature.signature = false;
                        this.modalSignature.signature = true;
                    })
            },
            cancerConfirmRecolha(){
                this.reason= null
                this.reasonOther= ''
                this.modalRecolha.egarId = 0
                this.modalRecolha.show = false
            },
            confirmCancelRecolha(){
                let body = {
                    egarId: this.modalRecolha.egarId,
                    reason: this.reason == 'other'? this.reasonOther : this.reason,
                    detachEgarFromRoute: this.reason == this.$t('environmental-management.route-management.edit-conveyor.disassociate-from-route')
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return RejectedEgar(body)
                    .then(response => {

                        //this.infoRoute.doneEgars = this.infoRoute.doneEgars +1
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg9')
                        this.modalAlert.show = true;

                        this.cancerConfirmRecolha()
                        this.getAllEGAR()
                    })
                    .catch(error => {
                        this.modalAlert.msg = this.$t('environmental-management.route-management.edit-conveyor.modal-complete-route.msg8')
                        this.modalAlert.show = true;

                        throw new Error('error to put RejectedEgar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', true);

                    })
            },

            getTransporter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetTransporterToRoute(this.routeId)
                    .then(response => {
                        this.transporterInfo.name = response.data.result.name
                        this.breadcrumb[2].title = this.transporterInfo.name

                        this.transporterInfo.nif = response.data.result.nif
                        this.transporterInfo.plateNumber = response.data.result.plateNumber
                        this.transporterInfo.transportationStartDate = response.data.result.transportationStartDate
                    })
                    .catch(error => {
                        throw new Error('error to get GetTransporterToRoute values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },

            handlerOnClick(id){
                this.$router.push({ name: 'environmentalManagementRouteManagementEditConveyor', params: { id: id}})
                this.$router.go();
            },
            getPreRoutes(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetTranporterRouters()
                    .then(response => {

                        if(response.data.result[0].routesNow){
                            this.routesTransporterNow = response.data.result[0].routesNow
                        }
                        if(response.data.result[0].routesTomorrow){
                            this.routesTransporterTomorrow =  response.data.result[0].routesTomorrow
                        }
                        if(response.data.result[0].routesOther){
                            this.routesTransporterOthers = response.data.result[0].routesOther
                        }

                        let routesArray = []
                        if(this.routesTransporterNow.length > 0){
                            this.routesTransporterNow.map(el => {
                                routesArray.push(el)
                            })
                        }

                        if(this.routesTransporterTomorrow.length > 0){
                            this.routesTransporterTomorrow.map(el => {
                                routesArray.push(el)
                            })
                        }

                        if(this.routesTransporterOthers.length > 0){
                            this.routesTransporterOthers.map(el => {
                                routesArray.push(el)
                            })
                        }
                        this.routes = routesArray
                    })
                    .catch(error => {
                        throw new Error('error to get list egar values', error);
                    })
            },

            getAllEGAR(options){

              // console.log('opt', options)

                this.filters = [];
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                    Object.assign(this.filters, {
                        pageSize: options ? options.itemsPerPage : 10,
                        hasRoutes: true,
                        routeId: this.routeId,
                        currentPage: options ? options.page : 1
                    }
                )
                return GetEgars(this.filters)
                    .then(response => {
                        this.egars = response.data.result;
                        if(response.data && response.data.totalRecords) {
                          this.totalItemsTable = response.data.totalRecords;
                        }

                        this.egars.map(el =>
                            {
                                Object.assign(el, {
                                    recolher: false
                                })
                            }
                        )
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.getPreRoutes();
                        this.filters= [];
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            calcPercentual(total, done){
                if(done > 0){
                    let calc = (done * 100);
                    return calc / total;
                }
                return 0
            },
            addNewResidue() {
              this.form.residuos.push({
                designation: "",
                lerCodeId: "",
                operationCodeId: 0,
                quantity: 0,
                groupCode: "",
                numberPgl: "",
                operations: [],
              })
            },
            handleDeleteResidue(residuo, index) {
              this.form.residuos.splice(index, 1);
            },
            async getSILiAmbContainerTypes() {
              this.$store.commit('loadings/setStateLoadingTemplate', true);
              await EnvironmentalDocServicesGetSILiAmbContainerTypes()
                .then(response => {
                  if(response.data.result) {
                    response.data.result.forEach(recipe => {
                      let newRecipe = {
                        ...recipe,
                        text: recipe.description,
                        value: recipe.containerTypeId
                      }
                      this.containerTypesItems.push(newRecipe);
                    })
                  } else {
                    this.containerTypesItems = [];
                  }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error EnvironmentalDocServicesGetSILiAmbContainerTypes', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            async printEgarForm() {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const filledResidues = this.form.residuos.filter(residue =>
                    residue.designation || residue.codigoLer || residue.quantity || residue.containerTypeID || residue.containerQuantity
                ).map(residue => {
                    const containerType = this.containerTypesItems.find(item => item.value === residue.containerTypeID);
                    return {
                        designation: residue.designation || "",
                        lerCode: residue.codigoLer || "",
                        quantity: residue.quantity === 0 ? "" : residue.quantity.toString(),
                        containerType: containerType ? containerType.text : null,
                        containerQuantity: residue.containerQuantity === 0 ? "" : residue.containerQuantity.toString()
                    };
                });

                const emptyRows = Array(filledResidues.length > 0 ? 0 : 16).fill({
                    designation: "",
                    lerCode: "",
                    quantity: "",
                    containerType: null,
                    containerQuantity: ""
                });

                let data = {
                    nif: this.form.producerEstablishment.nif,
                    name: this.form.producerEstablishment.name,
                    address: this.form.producerEstablishment.address,
                    postalCode: this.form.producerEstablishment.postalCode,
                    locality: this.form.producerEstablishment.locality,
                    createdDate: `${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}`,
                    residue: [...filledResidues, ...emptyRows]
                };

                return PostPrintEgarForm(data)
                    .then(response => {
                        const blob = new Blob([response.data], {type: 'application/pdf'});
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        window.open(link);
                    })
                    .catch(error => {
                        console.error('Error downloading EGAR form:', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            },
            checkProducerValidity() {
                const {
                    producerType,
                    producerEstablishment,
                    recipientEstablishment
                } = this.form;

                const isProducerValid =
                    producerType !== 0 &&
                    producerEstablishment.nif !== '' &&
                    producerEstablishment.name !== '' &&
                    producerEstablishment.address !== '' &&
                    producerEstablishment.postalCode !== '' &&
                    producerEstablishment.locality !== '' &&
                    producerEstablishment.apaCode !== '';

                const isRecipientValid =
                    recipientEstablishment.nif !== '' &&
                    recipientEstablishment.name !== '' &&
                    recipientEstablishment.address !== '' &&
                    recipientEstablishment.postalCode !== '' &&
                    recipientEstablishment.locality !== '' &&
                    recipientEstablishment.apaCode !== '';

                const isActorsSendersValid =
                    this.selectActorsSenders !== null &&
                    this.selectActorsSendersType !== null;

                this.modalNewEgar.valideProducer = isProducerValid && isRecipientValid && isActorsSendersValid;
            },
        },
        created(){
            this.routeId = this.$route.params.id
            this.getAllEGAR();
            this.getSILiAmbContainerTypes();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '@sass/_variables.scss';

    .row-signature{
        .canvas{
            width:100%;
        }
    }

    .rotation-180{
        transform: rotate(180deg);
    }

    .cursor-pointer{
        cursor: pointer;
    }

    .qtdKG {
        min-width: 80px !important;
        max-width: 80px;
        ::v-deep label{
            font-size: 12px;
        }

    }
    .h-80{
        min-height: 80px;
    }
    .tr-status{
        font-size: 15px;
        color: $green;
        ::v-deep svg{
            path{
                fill: $green;
            }
        }
    }
    .tr-kg{
        font-size: 13px;
        color: $grey;
        font-weight: 500;
    }
    .circle {
        background: #ccc;
        width: 30px;
        height: 30px;
        padding: 6px;
    }
    .no-get {
        background-color: #ff000000 !important;
        border: 1px solid red;
        color: red !important;
    }
    .get{
        background-color: #4caa5e !important;
        color: #fff !important;
    }
    ::v-deep table{
        thead {

            th{
                font-size: 13px !important;
                border: 1px solid rgb(224 224 224);
                height: 30px !important;
                background: $grey-light;
                color:rgb(113 113 113 / 60%) !important;
            }
        }
        tbody{
            td{
                border: 1px solid rgb(224 224 224);
                font-size: 13px !important;
                p{
                    margin-bottom: 0;
                    &.subTitle-table{
                        margin-top: 3px;
                        color: #c5c2c2;
                    }
                }
            }
        }
    }

    .danger-egar{
        .tr-status{
            font-size: 15px;
            color: $red;
            ::v-deep svg{
                path{
                    fill: $red;
                }
            }
        }
    }


    .btn-add{
        cursor: pointer;
        .circle{
            background: var(--v-primary-base);
            width: 40px;
            height: 40px;
            border-radius: 50%;

            ::v-deep path{
                fill: #ffffff !important;
            }
        }
        &:hover{
            .circle{
                background: var(--v-primary-lighten3);
            }
        }
    }
    .btn-remove{
      cursor: pointer;
      .circle{
          background: var(--v-error-base);
          width: 30px;
          ::v-deep path{
              fill: #ffffff !important;
          }
      }
      &:hover{
          .circle{
              background: var(--v-error-lighten3);
          }
      }
  }

    .secondary-button {
        border: 1px solid var(--v-primary-base);

        font-weight: 600;
        color: var(--v-primary-base);
        border-radius: 43px;
        background: transparent !important;

        &:hover {
            background: var(--v-primary-base) !important;
            color: #7a7a7a;
        }
    }
</style>
